"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferProducts = void 0;
var _mui = require("@ori-ui/mui");
var _productList = require("@ori/product-list");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const SingleOffer = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('./components/SingleOffer'))).then((module)=>({
            default: module.SingleOffer
        })));
const MultiOffer = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('./components/MultiOffer'))).then((module)=>({
            default: module.MultiOffer
        })));
const OfferProducts = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { totalRecords, loading, searchTerm } = (0, _contexts.useOfferDetail)();
    if (totalRecords === 0 && loading) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "data-testid": getTestId(_models.TestId.OfferListSkeleton),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productList.ListSkeleton, {})
        });
    }
    if (totalRecords === 0) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
            "data-testid": getTestId(_models.TestId.OfferNoProductsFound),
            variant: "body2",
            textAlign: "center",
            children: formatMessage('noProductsFound', {
                name: searchTerm
            })
        });
    }
    if (totalRecords === 1) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SingleOffer, {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MultiOffer, {});
};
exports.OfferProducts = OfferProducts;
